import { notification } from 'antd'
import ApiEndPoints from 'utils'
import apiClient from '../index'

export const getListEmpLeave = async ({ fromDashboard }) => {
  try {
    return await apiClient.get(`${`${ApiEndPoints.ALL_LEAVE}`}`, {
      params: {
        fromDashboard,
      },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}
export const getLeaveCount = async () => {
  try {
    return await apiClient.get(`${`${ApiEndPoints.LEAVE_COUNT}`}`)
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getListEmpDayLeave = async ({ fromDashboard }) => {
  try {
    return await apiClient.get(`${ApiEndPoints.ALL_DAYOFF_LEAVE}`, {
      params: {
        fromDashboard,
      },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

// eslint-disable-next-line consistent-return
export const addNewEmpLeave = async (leaveData, options = {}) => {
  try {
    return await apiClient.post(ApiEndPoints.MARK_LEAVE, leaveData, {
      suppressErrorNotification: options?.silent,
    })
  } catch (error) {
    return error?.response || null
  }
}

// eslint-disable-next-line consistent-return
export const updateEmpLeave = async (leaveData, id, options = {}) => {
  try {
    return await apiClient.put(`${ApiEndPoints.UPDATE_LEAVE}/${id}`, leaveData, {
      suppressErrorNotification: options?.silent,
    })
  } catch (error) {
    return error?.response || null
  }
}

export const getListEmpLeaveRequest = async (
  leaveStatus,
  skip,
  limit,
  employeeValue,
  moduleId,
  leaveType,
  sortBy,
  sortOrder,
) => {
  try {
    return await apiClient.get(ApiEndPoints.LEAVE_REQUEST, {
      params: {
        leaveStatus,
        skip,
        limit,
        employeeValue,
        moduleId,
        leaveType,
        sortBy,
        sortOrder,
      },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const updateLeaveStatus = async (data, id) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.UPDATE_LEAVE_STATUS}/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const deleteLeaveRequest = async (data, id) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.DELETE_LEAVE_REQUEST}/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getSingleLeaveRequestData = async (id, moduleId) => {
  try {
    return apiClient.get(`${ApiEndPoints.GET_SINGLE_LEAVE_REQUEST}/${id}`, {
      params: {
        moduleId,
      },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getEmpLeaveReport = async ({ skip, limit, userId, month, year }) => {
  try {
    return await apiClient.get(`employee/leaveReport/${userId}`, {
      params: {
        skip,
        limit,
        month,
        year,
      },
    })
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const checkPaidLeave = ({ userId, year, month }) => {
  return apiClient.get(`employee/checkPaidLeave/${userId}`, {
    params: {
      year,
      month,
    },
  })
}
